import React from "react";

import DashboardHomeView from "components/DashboardHomeView";
import useController from "./controller";

export default function DashboardHome() {
    const { hero, loading, sections, handleAction } = useController();

    return (
        <DashboardHomeView handleAction={handleAction} hero={hero} loading={loading} sections={sections} />
    );
}
